import React from 'react';

function WebTechMembers() {
  return <div>
      <h1> about this website.. which technology is used , how many developer worked etc...</h1>
  </div>;
}

export default WebTechMembers;
